import React from 'react';
import { FormattedDate } from 'react-intl';
import { Grid, ListItemAvatar, ListItemSecondaryAction, ListItemText, Tooltip } from '@mui/material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import {
	ButtonLink,
	Icon,
	ImageAvatar,
	MultiButton,
	SquareChip,
	TagsArray,
	Text,
	Utils,
	useSettings
} from 'app/main/components';
import buttons from './RequestsButtons';

export default function RequestsListItem(props: ItemLayoutProps) {
	const { t } = useSettings();

	const avatar = (
		<ImageAvatar
			dimensions={44}
			module="users"
			uid={props.model.tick_user_assigned_uid}
			avatar={props.model.user_assigned_avatar}
			initials={props.model.tick_title_initials}
			labelBadge={props.model.tist_title_initials}
			labelBadgeTooltip={props.model.tist_title}
			badgeColor={props.model.tist_color}
		/>
	);

	return (
		<GridListItem avatar={avatar} buttons={buttons.view?.itemButtons}>
			<Grid container justifyContent="space-between" spacing={1}>
				<Grid size={{ xs: props.width >= 720 ? 8 : 12 }}>
					<Grid container>
						<Grid size={12} className="inline-flex items-center">
							{/* WARNING */}
							{props.model.rqst_warning_desc && (
								<Tooltip title={props.model.rqst_warning_desc} arrow>
									<Icon className="mr-2" icon="alert-circle-outline" color="warning.main" />
								</Tooltip>
							)}
							{/* BLOCKED */}
							{props.model.rqst_blocked_desc && (
								<Tooltip title={props.model.rqst_blocked_desc} arrow>
									<Icon className="mr-2" icon="block" color="error.main" />
								</Tooltip>
							)}
							{/* TITLE */}
							<Text
								className="font-600"
								variant="subtitle2"
								to={{ module: 'requests', uid: props.model.reqs_uid }}
							>
								{props.model.reqs_title}
							</Text>
						</Grid>
						<Grid>
							{/* TYPE */}
							{props.model.rqty_title && (
								<SquareChip label={props.model.rqty_title} backgroundColor={props.model.rqty_color} />
							)}
						</Grid>
						<Grid>
							{/* CREATION DATE */}
							<SquareChip
								label={
									<FormattedDate
										value={Utils.parseDate(props.model.reqs_d_created)?.toDate()}
										year="2-digit"
										month="2-digit"
										day="2-digit"
										hour="2-digit"
										minute="2-digit"
									/>
								}
							/>
						</Grid>
						<Grid>
							{/* TAGS */}
							<TagsArray tags={props.model.rqst_tags} changeFilter={props.changeFilter} />
						</Grid>
						<Grid>
							{/* CLOSED DATE */}
							{props.model.reqs_d_to && (
								<SquareChip
									label={
										<FormattedDate
											value={Utils.parseDate(props.model.reqs_d_to)?.toDate()}
											year="2-digit"
											month="2-digit"
											day="2-digit"
										/>
									}
									icon={<Icon icon="check-circle" size={16} />}
									backgroundColor={theme => theme.palette.success.main}
								/>
							)}
						</Grid>
					</Grid>
				</Grid>
				{props.width >= 720 && (
					<Grid size={4}>
						{/* USER ASSIGNED */}
						<ButtonLink
							href={`/users/details/${props.model.reqs_user_assigned_uid}`}
							icon="account-circle"
							fallback={t('VIEW_ITEM_NO_INTREF')}
						>
							{props.model.user_assigned_title}
						</ButtonLink>
					</Grid>
				)}
			</Grid>
		</GridListItem>
	);
}
